module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./TransactionDetailView.js"));
	}, "TransactionDetailView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=TransactionDetailView!./src/pages/Store/Wallet/TransactionDetail/TransactionDetailView.js
// module id = 2145
// module chunks = 367